export interface InitAvatarConfig {
  avatar?: string;
  initial: string;
}

export enum ShopUserAvatarAttribute {
  Source = 'src',
  Initial = 'initial',
}
